import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'kt-update-alert',
  template: `
      <div matDialogTitle>{{'UPDATE_ALERT.TITLE' | translate}}</div>
      <div matDialogContent>{{'UPDATE_ALERT.CONTENT' | translate}}</div>
      <div matDialogActions>
        <button mat-button (click)="reload()">{{'UPDATE_ALERT.BUTTON' | translate}}</button>
      </div>
    `
})

export class UpdateAlertComponent {
  constructor() {
  }

  reload() {
    location.reload();
  }
}
